<div class="audit-detail">
  <div class="container-fluid">
    <div class="row audit-detail-header-container">
      <h3 class="audit-detail-header">
        <ng-container [ngSwitch]="audit.action">
          <span *ngSwitchCase="actionType.Delete">Deleted</span>
          <span *ngSwitchCase="actionType.Insert">Created</span>
          <span *ngSwitchCase="actionType.Update">Updated</span>
        </ng-container>
        by {{ audit.eventUser }} on
        {{ audit.eventDate | momentDate : 'MM/DD/YYYY HH:mm UTC' }}
      </h3>
    </div>
    <ng-container *ngFor="let auditField of audit.auditFields">
      <div class="row">
        <div class="col">{{ auditField.fieldName }}</div>
        <div class="col">{{ auditField.oldValue }}</div>
        <div class="col">⟹</div>
        <div class="col">{{ auditField.newValue }}</div>
      </div>
    </ng-container>
  </div>
</div>
